import { Redirect, Route, Switch } from "react-router-dom";
import Login from "./auth/login/Login";
import Reset from "./auth/reset/Reset";
import SetPassword from "./auth/setPassword/SetPassword";
import ThankYou from "./auth/thankYou/ThankYou";
import Account from "./account/Account";
import Signup from "./auth/signup/Signup";
import Dashboard from "./dashboard/Dashboard";
import Loading from "./_shared/components/Loading/Loading";
import { useAuth } from "./_shared/contexts/AuthContext";
import LoginWith42Macro from "auth/loginWith42Macro/LoginWith42Macro";

function ProtectedRoute({ children, ...rest }: any) {
  const { isAuthenticated, isAuthenticating } = useAuth();
  if (isAuthenticating) return <Loading message="Signing in..." />;
  return (
    <Route
      {...rest}
      render={() => {
        return isAuthenticated === true ? children : <Redirect to="/login" />;
      }}
    />
  );
}

function PublicRoute({ children, ...rest }: any) {
  const { isAuthenticated, isAuthenticating } = useAuth();
  if (isAuthenticating) return <Loading message="Signing in..." />;
  return (
    <Route
      {...rest}
      render={() => {
        return isAuthenticated ? (
          <Redirect
            to={
              rest?.path === "/42macro" ? "/account/integrations" : "/dashboard"
            }
          />
        ) : (
          children
        );
      }}
    />
  );
}

export const Routes = () => {
  return (
    <Switch>
      <PublicRoute path="/" exact>
        <Login />
      </PublicRoute>
      <PublicRoute exact path="/login">
        <Login />
      </PublicRoute>
      <PublicRoute exact path="/42macro">
        <LoginWith42Macro />
      </PublicRoute>
      {/* SIGNUP FLOW CONTAINS NESTED ROUTES */}
      <PublicRoute path="/signup">
        <Signup />
      </PublicRoute>
      <PublicRoute exact path="/reset">
        <Reset />
      </PublicRoute>
      <PublicRoute exact path="/set-password">
        <SetPassword />
      </PublicRoute>
      <PublicRoute exact path="/thank-you">
        <ThankYou />
      </PublicRoute>

      {/* PROTECTED ROUTES CONTAIN NESTED ROUTES */}
      <ProtectedRoute path="/dashboard">
        <Dashboard />
      </ProtectedRoute>
      <ProtectedRoute path="/account">
        <Account />
      </ProtectedRoute>
    </Switch>
  );
};
